/**
 * The configuration for the application
 */
const config = {
  environment: resolveEnv(['VITE_ENVIRONMENT', 'ENVIRONMENT']),
  domain: resolveEnv(['VITE_DOMAIN', 'DOMAIN']),
  posthog: {
    apiHost: clientEnv('VITE_POSTHOG_HOST'),
    apiKey: clientEnv('VITE_POSTHOG_API_KEY'),
  },
  koala: {
    apiKey: clientEnv('VITE_KOALA_API_KEY'),
  },
  gtm: {
    key: clientEnv('VITE_GTM_KEY'),
  },
  zaps: {
    hookUrl: serverEnv('ZAP_GLOBAL_HOOK_URL'),
  },
  calendly: {
    apiKey: serverEnv('CALENDLY_API_KEY'),
  },
};

export type Config = typeof config;

export default config;

/*
|------------------
| Internals
|------------------
*/

/**
 * Get an environment variable for the client
 *
 * @param key A key to resolve
 * @param options Options for the environment variable
 * @returns A resolved value for the key
 */
function clientEnv(key: string): string {
  return import.meta.env[key] ?? '';
}

/**
 * Get an environment variable for the server
 *
 * @param key A key to resolve
 * @param options Options for the environment variable
 * @returns A resolved value for the key
 */
function serverEnv(key: string): string {
  return process.env[key] ?? '';
}

/**
 * Get an environment variable from the client or server
 *
 * @param key A key to resolve
 * @param options Options for the environment variable
 * @returns A resolved value for the key
 */
function resolveEnv(keys: string[]): string {
  return keys.reduce((acc, key) => {
    const output = clientEnv(key) || serverEnv(key);

    if (output) {
      return output;
    }

    return acc;
  }, '');
}
